import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=78d75c04"
import script from "./admin-dashboard.vue?vue&type=script&lang=js"
export * from "./admin-dashboard.vue?vue&type=script&lang=js"
import style0 from "./admin-dashboard.vue?vue&type=style&index=0&id=78d75c04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports